export default __webpack_public_path__ + "assets/login_logo.904b5151ceeaa312452b910f95c70ab8.png";